export default function scrollToTop() {
  if (typeof window !== 'undefined') {
    window.scrollTo(0, 0);
  }
}
